import type { FeedPost, Organization } from '../types';

export const demoOrganization: Organization = {
  id: '00000000-0000-0000-0000-000000000001',
  slug: 'demo-campus',
  name: 'Instituto Horizonte',
  shortName: 'Horizonte',
  communityName: 'Horizonte Conecta',
  tagline: 'Tu escuela. Tu comunidad. Tu voz.',
  theme: {
    primary: '#3157d5',
    accent: '#f5b83d',
    surface: '#f5f7fb',
  },
};

export const demoPosts: FeedPost[] = [
  {
    id: 'post-1',
    author: { id: 'profile-1', name: 'Coordinación Académica', roleLabel: 'Cuenta oficial', initials: 'CA', verified: true },
    audience: 'Toda la comunidad',
    body: 'Esta semana abrimos el registro para los talleres de ciencia, creatividad y tecnología. Revisa los horarios y elige tu actividad desde Comunidades.',
    createdAt: 'Hace 18 min',
    kind: 'announcement',
    accent: '#3157d5',
    likes: 42,
    comments: 8,
  },
  {
    id: 'post-2',
    author: { id: 'profile-2', name: 'Club de Robótica', roleLabel: 'Comunidad', initials: 'CR' },
    audience: 'Secundaria y familias',
    body: 'Nuestro prototipo ya superó la primera prueba. Gracias a quienes aportaron ideas en la sesión abierta. El viernes compartiremos el proceso completo.',
    createdAt: 'Hace 2 h',
    kind: 'community',
    accent: '#6d4bd1',
    likes: 67,
    comments: 13,
  },
  {
    id: 'post-3',
    author: { id: 'profile-3', name: 'Vida Estudiantil', roleLabel: 'Equipo escolar', initials: 'VE', verified: true },
    audience: 'Toda la comunidad',
    body: 'El encuentro de familias será el sábado a las 10:00. Encontrarás el programa, ubicación y recomendaciones en la tarjeta del evento.',
    createdAt: 'Ayer',
    kind: 'event',
    accent: '#d05252',
    likes: 31,
    comments: 4,
  },
];

export const demoCommunities = [
  { id: '1', name: 'Robótica', members: 84, initials: 'RB', color: '#6d4bd1' },
  { id: '2', name: 'Arte y Cultura', members: 112, initials: 'AC', color: '#d95f84' },
  { id: '3', name: 'Familias', members: 238, initials: 'FA', color: '#2c8c78' },
  { id: '4', name: 'Deportes', members: 156, initials: 'DP', color: '#d47a2c' },
];

export const demoFamily = [
  {
    id: 'student-1',
    name: 'Sofía Galarraga',
    initials: 'SG',
    age: 15,
    grade: '3.º de secundaria',
    consentStatus: 'approved' as const,
    consentExpiresAt: '27 sep 2027',
    permissions: { publish: true, comment: true, media: false, tagging: false },
  },
  {
    id: 'student-2',
    name: 'Diego Galarraga',
    initials: 'DG',
    age: 13,
    grade: '1.º de secundaria',
    consentStatus: 'pending' as const,
    consentExpiresAt: null,
    permissions: { publish: false, comment: false, media: false, tagging: false },
  },
];
